import React from 'react';
import { Phone, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PHONE_NUMBER, INSTAGRAM_URL, VAT_NUMBER } from '../../config/constants';

const Footer = () => {
  return (
    <footer className="bg-black py-12 px-4 border-t border-zinc-800" data-testid="footer">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left flex items-center gap-4">
            <img src="/logo.png" alt="Roger'S Club Barberia" className="h-16 w-auto" />
            <div>
              <div className="text-xl font-serif font-bold tracking-wider mb-1">
                Roger'S Club Barberia
              </div>
              <p className="text-gray-500 text-sm">Gentleman Club · Pontassieve (FI)</p>
            </div>
          </div>

          <div className="flex gap-6">
            <a 
              href={INSTAGRAM_URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-amber-500 transition-colors"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <Instagram size={24} />
            </a>
            <a 
              href={`tel:${PHONE_NUMBER}`}
              className="text-gray-400 hover:text-amber-500 transition-colors"
              aria-label="Telefono"
              data-testid="footer-phone"
            >
              <Phone size={24} />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-zinc-800 text-center text-gray-500 text-sm">
          <p className="mb-2">&copy; {new Date().getFullYear()} Roger'S Club Barberia. Tutti i diritti riservati.</p>
          <p className="text-xs">
            Via Tanzini, 41 - 50065 Pontassieve (FI) | Tel: +39 331 885 7252
          </p>
          <p className="text-xs mt-1" data-testid="footer-vat">
            P.IVA: {VAT_NUMBER}
          </p>
          <div className="mt-4 flex justify-center gap-4 text-xs">
            <Link to="/privacy" className="text-gray-500 hover:text-amber-500 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/cookies" className="text-gray-500 hover:text-amber-500 transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
